module.exports = __webpack_public_path__ + "img/Male_Asian_Agent_W_Computer.a5cd885.png";